// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bkzXNbridATtlu {
  display: flex;
  padding: var(--ds-space-100, 8px);
}
.bkzXNbridATtlu span {
  min-width: 20px;
  margin-right: var(--ds-space-050, 4px);
}
.bokCo9l7CaPcqT {
  margin-bottom: var(--ds-space-0, 0);
  font-size: 11px;
  line-height: 14px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mirrorCardAccessRequestSubmitted": `bkzXNbridATtlu`,
	"content": `bokCo9l7CaPcqT`
};
export default ___CSS_LOADER_EXPORT___;
